export default "__VITE_ASSET__CdX8ujy$__"